export default __webpack_public_path__ + "static/media/B1_12.b0c1b25a.mp3";